import shared from './shared'
import breathing from './breathing'

export const modules = {
  shared,
  breathing,
}
